function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 2,
    r: 2,
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 8,
    r: 2,
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.125,
    cy: 14,
    r: 2,
    fill: props.fill
  }));
};
export default SvgMenu;